import { render } from "./TheImageViewer.vue?vue&type=template&id=6b9a7cce&scoped=true&ts=true"
import script from "./TheImageViewer.vue?vue&type=script&lang=ts"
export * from "./TheImageViewer.vue?vue&type=script&lang=ts"

import "./TheImageViewer.vue?vue&type=style&index=0&id=6b9a7cce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9a7cce"]])

export default __exports__